import { DataLayer } from "@sazka/utils/data-layer";

export namespace SearchAnalytics {
    export const pushSearchSuggester = (type: "main" | "help center", term: string, resultsCount: number) => {
        DataLayer.push({
            page: {
                type: "list.searchresults",
                kind: "whisperer",
                list: {
                    searchresults: {
                        type: `${type} search`,
                        term: term,
                        resultCount: resultsCount,
                    },
                    pageNumber: 1,
                },
            },
            event: "page",
        });
    };

    export const pushSearchResults = (type: "main" | "help center", term: string, resultsCount: number) => {
        DataLayer.push({
            page: {
                type: "list.searchresults",
                kind: "searchresults",
                list: {
                    searchresults: {
                        type: `${type} search`,
                        term: term,
                        resultCount: resultsCount,
                    },
                    pageNumber: 1,
                },
            },
            event: "pageReady",
        });
    };

    export const pushSuggesterClick = (category: string, name: string) => {
        DataLayer.push({
            event: "action.click.search",
            action: {
                click: {
                    category: category,
                    name: name,
                },
            },
        });
    };

    export const pushResultsClick = (category: string, name: string) => {
        DataLayer.push({
            event: "action.click.search",
            action: {
                click: {
                    category: category,
                    name: name,
                },
            },
        });
    };

    export const getVerticalByCategory = (category: string) => {
        switch (category) {
            case "lottery":
                return "loterie";
            case "ticket":
                return "losy";
            case "kasino":
                return "elosy";
            case "game":
                return "hry";
        }
    };

    export const getVerticalByUrl = (url: string) => {
        if (url.startsWith("/loterie")) {
            return "loterie";
        } else if (url.startsWith("/losy/stiraci-losy")) {
            return "losy";
        } else if (url.startsWith("/losy")) {
            return "elosy";
        } else if (url.startsWith("/hry")) {
            return "hry";
        }

        return "";
    };
}
